import { render, staticRenderFns } from "./DashExchange.vue?vue&type=template&id=478d10f2&"
import script from "./DashExchange.vue?vue&type=script&lang=js&"
export * from "./DashExchange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports